import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DatatableDataPageService<T = any> {
  dataPage = signal<T[]>([]);
  hasData = computed(() => Boolean(this.dataPage().length));
  hasNoData = computed(() => !this.hasData());
}
